export default __webpack_public_path__ + "static/media/11.da41c598.png";